(function () {
  'use strict';

  /* @ngdoc object
   * @name phases.newPhase
   * @description
   *
   */
  angular
    .module('neo.home.phases.newPhase', [
      'ui.router'
    ]);
}());
